// TODO: No point in converting to TypeScript. We should get rid of axios and use tRPC instead

import axios from 'axios';
import qs from 'qs';
import { authFailed, authChainFailed, fetchSystemStatus } from '@/lib/redux/redux-actions';
import { getFromLocalStorage } from './storage';

axios.defaults.withCredentials = process.env.SW_REACT_APP_ENV === 'production';

/*
const savedActiveEnv = getFromLocalStorage('activeEnv');
const activeEnv =
  savedActiveEnv ||
  (process.env.SW_REACT_APP_ENV === 'production' ? 'prod' : 'dev'); */

let store;

export const injectStore = (_store) => {
  store = _store;
};

const axiosInstance = axios.create({
  baseURL: process.env.SW_API_BASE_URL,
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'X-Requested-with': 'XHR',
  },
  validateStatus: function (status) {
    return status < 401; // Reject only if the status code is greater than or equal to 401
  },
  params: {},
  /*
  // If environment is selected, add get param to all requests
  params: activeEnv
    ? {
        environment: activeEnv,
      }
    : {}, */
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response.status === 401) {
      store.dispatch(authFailed());
    } else if (
      error.response.status === 403 &&
      error.response?.data?.message === 'USER_NO_CHAIN_RIGHTS'
    ) {
      store.dispatch(authChainFailed());
    } else if (
      error.response.status === 503 &&
      error.response?.data?.message === 'MAINTENANCE_BREAK'
    ) {
      store.dispatch(fetchSystemStatus(true));
    }

    // eslint-disable-next-line @typescript-eslint/prefer-promise-reject-errors
    return Promise.reject(error);
  }
);

function serializeParams(params) {
  return qs.stringify(params, { encode: false });
}

export { axiosInstance as axios, serializeParams };
